import React from 'react';
import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import './App.css';
import Pro from "./Pro2.jpg";
import ConAdd from "./ConAdd";
import { Tabs, Tab } from 'react-bootstrap';


function AuthenticationForm2({ onAddLogin, onaddKonsultit, onAddMandaatit, onAddTcg, onAddGroup, language = '' }) {
    const [isLoginForm, setIsLoginForm] = useState(true);
    const [email, setEmail] = useState("");
    const [sessionEmail, setSessionEmail] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [sessionPassword, setSessionPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [forgot, setForgot] = useState(false);
    const [finland, setFinland] = useState(false);
    const [logIn, setLogIn] = useState(false);
    const [konsultit, setKonsultit] = useState([]);
    const [titles, setTitles] = useState({signin: "Sign in",
    signup: "Sign up",
    forgot: "Forgot your password?",
    email: "Email",
    password:"Password",
    update: "Password update",
    placeemail: "Your email",
    yourpass: "Your password",
    yourpass2: "Admin password",
    createpass: "Create password",
    submit: "submit",
    new: "New password",
    loading: "Loading...",
    id : "User ID",
    id2 : "Use your user ID to log in",
    id3 : "Log in with admin ID",
    consultantTab: "Consultant",
    adminTab: "Admin",
    managementPageTitle: "Management page"})

    const titlesFi = {
      signin: "Kirjaudu sisään",
        signup: "Rekisteröidy",
        forgot: "Unohditko salasanasi?",
        email: "Sähköposti",
        password:"Salasana",
        update: "Salasanan uusiminen",
        placeemail: "Sinun sähköpostiosoite",
        yourpass: "Sinun salasanasi",
        yourpass2: "Adminin salasana",
        createpass: "Luo uusi salasana",
        submit: "Lähetä",
        new: "Uusi salasana",
        loading: "Hetkinen...",
        id : "Käyttäjätunnus",
        id2 : "Kirjaudu sisään sähköpostilla",
        id3 : "Kirjaudu sisään admintunnuksella",
        consultantTab: "Konsultti",
        adminTab: "Admin",
        managementPageTitle: "Hallintasivu"
      }

      const titlesEng = {
        signin: "Sign in",
        signup: "Sign up",
        forgot: "Forgot your password?",
        email: "Email",
        password:"Password",
        update: "Password update",
        placeemail: "Your email",
        yourpass: "Your password",
        yourpass2: "Admin password",
        createpass: "Create a new password",
        submit: "submit",
        new: "New password",
        loading: "Loading...",
        id : "User ID",
        id2 : "Use your user ID to log in",
        id3 : "Log in with admin ID",
        consultantTab: "Consultant",
        adminTab: "Admin",
        managementPageTitle: "Management page"
        }

      const titlesSwe = {
        signin: "Logga in",
        signup: "Registrera",
        forgot: "Glömt ditt lösenord?",
        email: "E-post",
        password:"Lösenord",
        update: "Uppdatera lösenord",
        placeemail: "Din e-post",
        yourpass: "Ditt lösenord",
        yourpass2: "Admin-lösenord",
        createpass: "Skapa nytt lösenord",
        submit: "Skicka",
        new: "Nytt lösenord",
        loading: "Laddar...",
        id : "Användar-ID",
        id2 : "Logga in med ditt användar-ID",
        id3 : "Logga in med administratörs-ID",
        consultantTab: "Konsult",
        adminTab: "Admin",
        managementPageTitle: "Administrationssida"
        }

      

    const [info, setInfo] = useState('');
    const [info2, setInfo2] = useState('');

  const [selectedRole, setSelectedRole] = useState('konsultti');


    useEffect(() => {

      if (konsultit.length > 0) {
        onAddLogin(true);
      }
    }, [konsultit]);
    useEffect(() => {

      console.log(selectedRole);
    }, [selectedRole]);

    useEffect(() => {
      const storedLanguage = localStorage.getItem('consultantLanguagePreference');

      if (!language && storedLanguage) {
        if (storedLanguage === 'fi') {
          setFinland(true);
          setTitles(titlesFi);
        } else if (storedLanguage === 'sv') {
          setFinland(false);
          setTitles(titlesSwe);
        } else {
          setFinland(false);
          setTitles(titlesEng);
        }
        return;
      }

      if (!language) {
        const domain = window.location.hostname;

        if (domain === 'theinterviewsimulator.com' || domain === 'www.theinterviewsimulator.com') {
          setFinland(false);
          setTitles(titlesEng);
        } else {
          setFinland(true);
          setTitles(titlesFi);
        }
        return;
      }

      if (language === 'fi' || language === 'Suomi') {
        setFinland(true);
        setTitles(titlesFi);
      } else if (language === 'sv' || language === 'Ruotsi') {
        setFinland(false);
        setTitles(titlesSwe);
      } else {
        setFinland(false);
        setTitles(titlesEng);
      }
    }, [language]);

    useEffect(() => {
      const loginStatus = sessionStorage.getItem("login");
      console.log(loginStatus);
      if (loginStatus){
        handleSend();
      }
    }, []);

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        handleSend(e);
      }
      else if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation(); 
        // Voit myös tehdä muita toimintoja tässä, jos haluat
      }
    };
    const handleKeyDown2 = (e) => {
      if (e.key === 'Enter') {
        handleSend(e);
      }
      else if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation(); 
        // Voit myös tehdä muita toimintoja tässä, jos haluat
      }
    };
    
      const handleSend = async (event) => {


        // Jos kaikki tarkistukset menevät läpi, tyhjennä info ja jatka lomakkeen lähettämistä
        setInfo("");
        setInfo2("");
        if (event) {event.preventDefault();     sessionStorage.setItem("pass", password);
        sessionStorage.setItem('email', email);}

        console.log(sessionEmail);
        console.log(sessionPassword);
        

    
        
        

        setIsLoading(true);

        const bodyData = sessionStorage.getItem('email')?.length > 1
  ? { 
      email: sessionStorage.getItem('email'), 
      pass: sessionStorage.getItem('pass'), 
      nimi: name 
    }
  : { 
      email, 
      pass: password, 
      nimi: name 
    };
          //fetch('http://localhost:5001/tcgai-c07e9/us-central1/api/managment', {
          fetch('https://us-central1-tcgai-c07e9.cloudfunctions.net/api/managment', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(bodyData)
        })
  
        .then(response => response.json())
        .then(data => { 
      
            setIsLoading(false);
            console.log(data.group);
            onAddGroup(data.group);
            
            if (data.status == "tryout" || data.status == "member" ){
 
              
     
            }else if (data.status == "väärä passu"){
              if(!finland){
                setInfo("Annettu salasana ei kelpaa.");
              setInfo2("Annettu salasana ei kelpaa.");
              }else{
                setInfo("Annettu salasana ei kelpaa.");
              setInfo2("Annettu salasana ei kelpaa.");
              }
            }else if (data.status == "ok"){//jos löytyi mandaatit, eli konsultti kyseessä
              
               onAddMandaatit(data.lois,data.lois2, data.lois3, data.name);
                sessionStorage.setItem("group", data.group);
                sessionStorage.setItem("login", true);
                setSessionPassword(sessionStorage.getItem("pass"));
                setSessionEmail(sessionStorage.getItem("email"));
                    
              }
            
            else if (data.status == "väärä id"){
              if(!finland){
                setInfo("väärä id");
              setInfo2("väärä id");
              }else{
                setInfo("väärä id");
              setInfo2("väärä id");
              }
            }
            else if (data.status == "ok tyhjä"){//ei löytynyt mandaattia, eli konsultti kyseessä
           
              const temp = ["Ei löytynyt mandaattia"];
           
                sessionStorage.setItem("group", data.group);
                sessionStorage.setItem("login", true);
                setSessionPassword(sessionStorage.getItem("pass"));
                setSessionEmail(sessionStorage.getItem("email"));
                    
                onAddMandaatit(temp);
              }
            else if (data.status == "pass true"){
              if(!finland){
                setInfo("pass true");
              setInfo2("pass true");
              }else{
                setInfo("pass true");
              setInfo2("pass true");
              }
            }else if (data.status == "login"){ //admin kyseessä
              console.log("pöö");
              if (data.tyyppi == "tcg"){ //jos tcg jantteri, tallennetaan true
                onAddTcg(true) 
              }else {
                onAddTcg(false) 
              }
              const temp = ["Ei konsultteja"];
                if (data.konsultit < 1){
                  console.log("pöö2");
                  setKonsultit(temp);
                onaddKonsultit(temp);
           
                }else{
                  console.log("pöö3");
                  setKonsultit(data.konsultit);
                onaddKonsultit(data.konsultit);
           
                }
                
              }
            else {
              if(!finland){
              setInfo("Something went wrong, please contact Lassi.");
              setInfo2("Something went wrong, please contact Lassi.");
              }else {
                setInfo("Jotain meni pieleen, ole hyvä ja ota yhteyttä Lassiin.");
                setInfo2("Jotain meni pieleen, ole hyvä ja ota yhteyttä Lassiin.");
              }
            }
          }
        ) 
        .catch(error => console.error(error));  

        setInfo("");
        setInfo2("");
        
        //setInfo2("Coming soon!");
      };


      useEffect(() => {
        const handleKeyDown = (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
          }
        };
        const handleKeyDown2 = (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
          }
        };
    
    
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keydown', handleKeyDown2);
        
    
        // Komponentin poistuessa, poista tapahtumankäsittelijä
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
          window.removeEventListener('keydown', handleKeyDown2);
        };
      }, []);

      const handleClosee = () => {
        setInfo2(""); // Nollaa info2:n arvo
      };

      const myRef = useRef();

      useEffect(() => {
        myRef.current.focus();
      }, []);
  
    if (!isLoading && !forgot && info2 == "" && !logIn){
      return (
  <>
    <style>
      {`
        .custom-input::placeholder {
          color: #f0f0f0;
          opacity: 1;
        }
        .custom-input:focus {
          border-color: #ffd700;
          box-shadow: 0 0 0 0.2rem rgba(255, 215, 0, 0.5);
          outline: none;
        }
      `}
    </style>

    <div style={{ backgroundColor: "#2c2c2c", minHeight: "150vh", color: "white", padding: "0" }}>
      {/* Otsikko ja Tabs */}
      <div style={{ textAlign: "center",padding: "20px" }}>
        <img
          className="FormLogo"
          src={Pro}
          alt="Logo"
          style={{
            height: "20vh",
            marginBottom: "10px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        />
        <h1 className="FormTitle" style={{ fontSize: "1.95em", marginBottom: "1vh" }}>
          {titles.managementPageTitle}
        </h1>
        <h3 style={{ fontSize: "1.1em" }}>
          {titles.signin}
        </h3>

        {/* Tabs vasempaan reunaan */}
        <div style={{ maxWidth: "400px", marginBottom: "-20px" }}>
          <Tabs
            activeKey={selectedRole}
            onSelect={(k) => setSelectedRole(k)}
            className="mb-2"
            variant="pills"
          >
            <Tab eventKey="konsultti" title={titles.consultantTab} />
            <Tab eventKey="admin" title={titles.adminTab} />
          </Tabs>
        </div>
      </div>

      {/* Lomake keskitettynä */}
      <Container >
        <Row className="justify-content-center">
          
            <Card className="Card" style={{ backgroundColor: "#3a3a3a", color: "white" }}>
              <Card.Body
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  borderRadius: "0",
                 
                 
                }}
              >
                <Form >
                  <Form.Group>
                    <Form.Label htmlFor="email" style={{ color: "white" }}>
                      {titles.id}
                    </Form.Label>
                    <Form.Control
                      id="email"
                      type="email"
                      ref={myRef}
                      placeholder={selectedRole === "admin" ? titles.id3 : titles.id2}
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyDown={handleKeyDown}
                      style={{ backgroundColor: "#555", color: "white", border: "1px solid #777" }}
                      className="custom-input"
                    />
                    <Form.Label htmlFor="password" style={{ paddingTop: "1vh", color: "white" }}>
                      {titles.password}
                    </Form.Label>
                    <Form.Control
                      id="password"
                      type="password"
                      placeholder={selectedRole === "admin" ? titles.yourpass2 : titles.yourpass}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={handleKeyDown}
                      style={{ backgroundColor: "#555", color: "white", border: "1px solid #777" }}
                      className="custom-input"
                    />
                  </Form.Group>
                </Form>
                <Button
                  className="SignIn"
                  variant="primary"
                  type="submit"
                  style={{
                    marginTop: "2vh",
                    width: "40%",
                    marginRight: "auto",
                    marginLeft: "auto",
                    backgroundColor: "#2c2c2c",
                    borderColor: "#2c2c2c",
                    color: "#ffffff"
                  }}
                  onClick={(e) => handleSend(e)}
                >
                  {titles.signin}
                </Button>
              </Card.Body>
            </Card>
            <div className="formInfo" style={{ color: "white", marginTop: "10px" }}>{info}</div>
        
        </Row>
      </Container>
    </div>
  </>
)}

    else if (logIn){

      return (
        <div>
         {logIn && konsultit.length > 0 && (
            <div>
              <ConAdd lan={finland} kon={konsultit} />
            </div>
          )}
        </div>

      );
    }
    else {
      return (

        <div style={{ textAlign: "center" }}>
          <img className="logopikku" src={Pro} alt="kuva" />
          {info2 == "" && (
            <div>
          <p>{titles.loading}</p>
          </div>
          )}
          {info2 !== "" && (
            <div>
              <p>{info2}</p>
              
              <Button
                    className='SignIn'
                    variant="primary"
                    type="submit"
                    style={{marginTop:"0vh", width:"40%", marginRight:"auto", marginLeft:"auto"}}
                    onClick={(e)=> handleClosee(e)}
                    >
                    {finland ? <p>Sulje</p> : <p>Close</p>}
                  
                </Button>
            </div>
          )}
        </div>
      );
    }
    ;}

export default AuthenticationForm2;
